import { render, staticRenderFns } from "./importResult.vue?vue&type=template&id=3c27f010&scoped=true&"
import script from "./importResult.vue?vue&type=script&lang=js&"
export * from "./importResult.vue?vue&type=script&lang=js&"
import style0 from "./importResult.vue?vue&type=style&index=0&id=3c27f010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27f010",
  null
  
)

component.options.__file = "importResult.vue"
export default component.exports